
import React, { useState, useEffect } from "react";
import { X, Info, Plus, ArrowDown } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

export const HomeScreenPrompt = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);

  useEffect(() => {
    // Only show on mobile devices when the prompt hasn't been shown before
    if (isMobile && !localStorage.getItem("homeScreenPromptShown")) {
      // Delay showing the prompt to let the app load first
      const timer = setTimeout(() => {
        setIsOpen(true);
        // Mark that we've shown the prompt
        localStorage.setItem("homeScreenPromptShown", "true");
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent side="bottom" className="max-h-[85vh] rounded-t-xl">
        <SheetHeader className="pb-4">
          <SheetTitle className="text-center text-xl flex items-center justify-center gap-2">
            <Info className="h-5 w-5 text-blue-500" />
            Add to Home Screen
          </SheetTitle>
        </SheetHeader>
        
        <div className="space-y-4 py-2">
          <div className="bg-blue-50 p-3 rounded-lg text-blue-700 text-sm">
            Install this app on your device for quick access and a better experience.
          </div>
          
          {isIOS && (
            <div className="space-y-3">
              <h4 className="font-medium">For iOS devices:</h4>
              <ol className="space-y-3 list-decimal pl-5 text-sm">
                <li>Tap the <span className="inline-flex items-center border px-2 py-1 rounded text-xs"><ArrowDown className="h-3 w-3 mr-1" /> Share</span> button at the bottom of your browser</li>
                <li>Scroll and tap <span className="inline-flex items-center border px-2 py-1 rounded text-xs"><Plus className="h-3 w-3 mr-1" /> Add to Home Screen</span></li>
                <li>Tap "Add" in the top right</li>
              </ol>
            </div>
          )}
          
          {isAndroid && (
            <div className="space-y-3">
              <h4 className="font-medium">For Android devices:</h4>
              <ol className="space-y-3 list-decimal pl-5 text-sm">
                <li>Tap the menu button (⋮) in your browser</li>
                <li>Tap "Add to Home screen"</li>
                <li>Tap "Add" to confirm</li>
              </ol>
            </div>
          )}

          {!isIOS && !isAndroid && (
            <div className="space-y-3">
              <h4 className="font-medium">Installation steps:</h4>
              <ol className="space-y-3 list-decimal pl-5 text-sm">
                <li>Open the menu in your browser</li>
                <li>Look for "Add to Home screen" or "Install App" option</li>
                <li>Follow the prompts to install</li>
              </ol>
            </div>
          )}
        </div>
        
        <SheetFooter className="pt-4">
          <Button 
            onClick={() => setIsOpen(false)} 
            className="w-full"
          >
            Got it
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};
